export default {
  prjRole: state => state.project.role,
  path: state => state.project.path,
  activeTab: state => state.project.activeTab,
  status: state => state.project.status,
  name: state => state.project.name,
  prjType: state => state.project.prjType
}
